import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import React, { useEffect } from 'react';

import { OperationType } from '../../../../../../../../../components/OperationType';
import { ResponsiveSuccessIconButton } from '../../../../../../../../../components/ResponsiveSuccessIconButton';
import { useFixedIncomeSellAssetController } from '../../../../../hooks/products/FixedIncomeSell';
import { LateralBar } from '../../../components/LateralBar';

import { FixedIncomeItemSelectedTypes } from '.';

export const FixedIncomeItemSelectedMobile: React.FC<FixedIncomeItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
  hideLateralBar = false,
}) => {
  const id = offer.productIdNormalized;
  const {
    amountItem,
    handleChangeAmountItem,
    errorMessage,
    hasError,
    netFinancialValue,
    netFinancialValueFormatted,
  } = useFixedIncomeSellAssetController(offer);

  useEffect(() => {
    if (offer.orderQuantity === amountItem || !amountItem) {
      return;
    }
    const updatedOffer = {
      ...offer,
      orderQuantity: amountItem || 0,
      orderValue: netFinancialValue,
    };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amountItem]);

  const middleInfos = [
    {
      label: 'Tipo',
      value: <OperationType title="Resgate" />,
    },
    {
      label: 'Quantidade disponível',
      value: <UI.Text color="neutral.dark">{offer.availableQuantityNormalized}</UI.Text>,
    },
    {
      label: 'IR',
      value: <UI.Text color="neutral.dark">{offer.irFormatted}</UI.Text>,
    },
    {
      label: 'Valor líquido',
      value: <UI.Text color="neutral.dark">{netFinancialValueFormatted}</UI.Text>,
    },
    {
      label: 'Disponível em conta',
      value: <UI.Text color="neutral.dark">{offer.availableInAccountNormalized}</UI.Text>,
    },
  ];

  return (
    <VStack space="stack.xxxs" w="full">
      {!hideLateralBar && (
        <LateralBar
          backgroundColor="product.rf"
          borderTopLeftRadius={BoxRadius.sm}
          borderBottomLeftRadius={BoxRadius.sm}
        />
      )}
      <VStack space="stack.nano">
        <UI.Text variant="semibold" color="neutral.black">
          {offer.issuerFullName}
        </UI.Text>
      </VStack>
      <VStack space="stack.nano" flexGrow={1}>
        {middleInfos.map(({ label, value }) => (
          <HStack
            alignItems="center"
            space="inline.quarck"
            justifyContent="space-between"
            key={label}>
            <UI.Text color="neutral.black" variant="semibold">
              {label}
            </UI.Text>
            {value}
          </HStack>
        ))}
      </VStack>
      <HStack
        space={Spacing['inline.xxxs']}
        justifyContent="space-between"
        w="full"
        alignItems="flex-end">
        <VStack space={Spacing['stack.quarck']} flexGrow={1}>
          <UI.Text color="neutral.black" variant="semibold">
            Quantidade solicitada
          </UI.Text>
          <VStack flex={1}>
            <UI.InputStepper
              stepperValue={1}
              max={offer.availableAmount}
              min={1}
              name={`fixed-income-amount-order-input-${id}`}
              keyboardType="numeric"
              fontSize={Typography['fontsize.md']}
              defaultValue={amountItem || 0}
              onChange={handleChangeAmountItem}
              showErrorMessage={false}
              {...(hasError && {
                customError: errorMessage,
                showErrorMessage: true,
              })}
            />
          </VStack>
        </VStack>
        <ResponsiveSuccessIconButton />
      </HStack>
    </VStack>
  );
};
